/**
 * CSM Staffing module layout — a top-level module, peer of Chat / Customer
 * Management / Hotel Supplier Management / Expense.
 *
 * Reuses CrmModuleShell (the .crm-scope styling boundary + MeProvider + the
 * capability-gated pill-tab bar) because this module reads cm-api and shares the
 * CRM's surface and styling. Tabs come from the PAGE REGISTRY, not a local array,
 * so the left rail, the tab bar, and Admin > Users all describe the same access.
 *
 * StaffingDataProvider sits ABOVE the shell so the five reads happen once for the
 * module rather than once per tab — switching Overview ↔ Portfolios re-renders
 * from the same book instead of re-fetching it.
 */
import { moduleTabs } from '@/features/admin/lib/page-registry';
import type { Capability } from '@/features/crm/auth/roles';
import { CrmModuleShell, type ModuleTab } from '@/features/crm/CrmModuleShell';
import { StaffingDataProvider } from './StaffingDataProvider';

export const CSM_STAFFING_TABS: ModuleTab[] =
  moduleTabs<Capability>('csm-staffing');

export function CsmStaffingLayout() {
  return (
    <StaffingDataProvider>
      <CrmModuleShell
        subtitle="Service tiers, team slots and portfolio balance, computed from the CRM book."
        tabs={CSM_STAFFING_TABS}
        title="CSM Staffing"
      />
    </StaffingDataProvider>
  );
}
